@use "ui/styles/colorsOld";

.wrapper {
    font-size: 14px;
    margin-top: 1.5em;
    max-height: 120px;
    overflow-y: auto;
    background-color: colorsOld.$stoneLightX5;
    border-radius: 4px;
    padding: 1.5em;

    .baseOption {
        display: flex;
        align-items: center;
        margin-bottom: 0.25em;
        gap: 1em;

        .label {
            font-weight: 400;
            width: 65%;
        }

        .price {
            font-weight: 300;
            font-size: 12px;
            display: flex;
        }
    }
}